import {Component, OnInit} from '@angular/core';
import {
  FormBuilderService,
  ApplicationService,
  NotificationService,
  WorkbookService,
  CommunicationService,
  SalesService,
  SubmissionService, TypesService
} from '../../services';
import {WizardFormComponent, WizardSteps} from './wizard-form.component';
import {BaseSubmissionModel} from '../../models/submission/base-submission-model';
import { UntypedFormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {IndividualPersonModel} from '../../models/widgets/personal-details-model';
import {DomSanitizer} from '@angular/platform-browser';
import {OAuthService} from 'angular-oauth2-oidc';
import {Router, ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';
import {LCA_ORIGINATOR_PARTY_ROLE_ID} from '../../_global/wiz.constants';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrokerNotesComponent } from '../widgets/broker-notes/broker-notes.component';
import { ProductComponent } from '../widgets/product/product.component';
import { RateComponent } from '../widgets/rate/rate.component';
import { SolicitorBorrowerDetailsComponent } from '../widgets';
import { SolicitorPanelDetailsComponent } from '../widgets';
import { SecurityDetailsComponent, HomeLoanDetailsComponent, ApplicationTypeComponent, LoanDetailsTermsComponent, QuotesListComponent,
  QuoteDetailsComponent, BalloonAmountComponent, LoanTermsComponent, SingleSplitLoanAmountComponent, LoanDetailsComponent, BusinessCarLoanDetailsComponent,
  PersonalDetailsComponent, CompanyDetailsComponent, BorrowerTypeComponent, AbnAcnComponent, CustomerDetailsComponent, OriginatorBrokerComponent} from '../widgets';
import { ConfirmationComponent } from '../widgets/confirmation/confirmation.component';
import { SubmitComponent } from '../widgets/submit/submit.component';
import { DocumentUploadComponent } from '../widgets/documents-upload/documents-upload.component';
import { AutoCollateralComponent } from '../widgets/auto-collateral/auto-collateral.component';
import { ExpensesDetailsComponent } from '../widgets/expense-details/expenses-details.component';
import { LiabilitiesDetailsComponent } from '../widgets/liabilities-details/liabilities-details.component';
import { AssetsDetailsComponent } from '../widgets/assets-details/assets-details.component';
import { IncomeDetailsComponent } from '../widgets/income-details/income-details.component';
import { InvestmentIncomeComponent } from '../widgets/investment-income/investment-income.component';
import { EmploymentDetailsComponent } from '../widgets/employment-details/employment-details.component';
import { TrustDetailsComponent } from '../widgets/trust-details/trust-details.component';
import { BorrowerTypeEnhancedComponent } from '../widgets/borrower-type-enhanced/borrower-type-enhanced.component';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import {DataHandlerService} from '../../services/data-handler.service';

@Component({
    templateUrl: './wizard-form.component.html',
    standalone: true,
    imports: [MatSidenavModule, NgClass, MatProgressBarModule, NgIf, MatListModule, NgFor, MatButtonModule, MatButtonModule, FormsModule, OriginatorBrokerComponent, ReactiveFormsModule, CustomerDetailsComponent, AbnAcnComponent, BorrowerTypeComponent, BorrowerTypeEnhancedComponent, TrustDetailsComponent, CompanyDetailsComponent, PersonalDetailsComponent, BusinessCarLoanDetailsComponent, LoanDetailsComponent, SingleSplitLoanAmountComponent, LoanTermsComponent, BalloonAmountComponent, EmploymentDetailsComponent, InvestmentIncomeComponent, IncomeDetailsComponent, AssetsDetailsComponent, LiabilitiesDetailsComponent, ExpensesDetailsComponent, AutoCollateralComponent, DocumentUploadComponent, SubmitComponent, ConfirmationComponent, QuoteDetailsComponent, QuotesListComponent, LoanDetailsTermsComponent, ApplicationTypeComponent, HomeLoanDetailsComponent, SecurityDetailsComponent, SolicitorPanelDetailsComponent, SolicitorBorrowerDetailsComponent, RateComponent, ProductComponent, BrokerNotesComponent, MatProgressSpinnerModule, MatProgressSpinnerModule]
})
export class ConsumerAutoComponent extends WizardFormComponent implements OnInit {
  public wizardName = 'Personal Secured Asset Loan';
  public baseModel: BaseSubmissionModel;
  public storageIdentifier = 'wiz-consumer-auto'; // the key for session storage
  public loanPurposeType = 'motor-vehicle-loan';
  public salesRelatesTo = 'car-loan';
  public blurbUrl = '/general_terms_default.html';
  public blurbText = '';
  public isPersonalLoan = true;
  public steps: WizardSteps[] = [{
    icon: 'arrow_forward',
    name: 'Your details',
    widgets: [
      {name: 'app-originator-broker', class: 'col-sm-12'},
      {name: 'app-customer-details', class: 'col-sm-12'},
      {name: 'app-borrower-type', class: 'col-sm-12'},
      {name: 'app-application-type', class: 'col-sm-12'},
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Consumer details',
    widgets: [
      {name: 'app-personal-details', class: 'col-sm-12'}
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Income details',
    widgets: [
      // { name: 'app-income-details', class: 'col-sm-12' },
      {name: 'app-employment-details', class: 'col-sm-12'}, // uncomment once self-employed is ready
      {name: 'app-investment-income', class: 'col-sm-12'}
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Assets & Liabilities details',
    widgets: [
      {name: 'app-assets-details', class: 'col-sm-12'},
      {name: 'app-liabilities-details', class: 'col-sm-12'},
      {name: 'app-expenses-details', class: 'col-sm-12'}
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Loan details',
    widgets: [
      {name: 'app-loan-details-terms', class: 'col-md-12 col-lg-6', opts: {vehicleUsage: 'personal'}},
      {name: 'app-single-split-loan-amount', class: 'col-md-12 col-lg-6'},
      {name: 'app-rate', class: 'col-sm-12'},
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Submission',
    widgets: [
      {name: 'app-submit', class: 'col-sm-12'},
      {name: 'app-docs-upload', class: 'col-sm-12'},
      {name: 'app-broker-notes', class: 'col-sm-12'}
    ],
    classNameStatus: 'default'
  }, {
    icon: 'arrow_forward',
    name: 'Confirmation',
    widgets: [
      {name: 'app-confirmation', class: 'col-sm-12'}
    ],
    classNameStatus: 'default'
  }];

  constructor(public formBuilderService: FormBuilderService,
              public dataHandlerService: DataHandlerService,
              public submissionService: SubmissionService,
              public applicationService: ApplicationService,
              public notificationService: NotificationService,
              public sanitizer: DomSanitizer,
              public oauthService: OAuthService,
              public router: Router,
              public activatedRoute: ActivatedRoute,
              public workbookService: WorkbookService,
              public typesService: TypesService,
              public communicationService: CommunicationService,
              public salesService: SalesService) {
    super(formBuilderService, dataHandlerService, submissionService, applicationService, notificationService, sanitizer, oauthService,
      router, activatedRoute, workbookService, typesService, communicationService, salesService);
    console.log('[consumer-auto]', 'Init Consumer Secured Asset Application');
    this.dataHandlerService.sendProductCategory('secured-asset');
  }

  ngOnInit() {
    super.ngOnInit();
    this.afterInit();
  }

  public afterInit() {
    this.isPartComplete = true;
    this.baseform.get('step-0').get('app-application-type').get('applicationType').clearValidators();

    if (this.baseform && this.baseform.get('step-1') && this.baseform.get('step-1').get('app-personal-details')) {
      // set the details based on the step where they are located
      this.personalDetails = (this.baseform.get('step-1').get('app-personal-details').get('personList') as UntypedFormArray);
      this.setListValidators();
    }

    // set the investment form array
    if (this.baseform && this.baseform.get('step-3') && this.baseform.get('step-3').get('app-investment-income')) {
      this.investmentFormArray = (this.baseform.get('step-3').get('app-investment-income').get('investmentList') as UntypedFormArray);
    }

    // make these empty form arrays
    this.trustDetails = new UntypedFormArray([]);
    this.companyDetails = new UntypedFormArray([]);
  }

  public getGeneralBlurb() {
    if (this.blurbText === '') {
      return this.sanitizer.bypassSecurityTrustHtml(
        `<div>
        <h5>I confirm</h5>
        <ul>
          <li>The vehicle that is the subject of the application will be used wholly or predominantly for personal use</li>
          <li>The information that I have provided in this loan application is true and correct</li>
          <li>I have read the privacy declaration and consent to Firstmac collecting, using and providing my personal details and credit information to process my loan application in accordance with those terms</li>
        </ul>
        </div>`
      );
    } else {
      return this.sanitizer.bypassSecurityTrustHtml(`${this.blurbText}`);
    }
  }

  private setListValidators() {
    this.personalDetails.controls.forEach(fg => {
      this.formBuilderService.setValidationRules(new IndividualPersonModel(), fg);
    });
  }

  /**
   * Hook into before submit to do form-specific logic
   * @param data
   */
  public formBeforeSubmit(data) {
    // check if session storage has lead
    let lead;
    try {
      lead = JSON.parse(sessionStorage.getItem(this.storageIdentifier + '-lead'));
    } catch {
      console.log('Unable to parse lead from session storage: ' + sessionStorage.getItem(this.storageIdentifier + '-lead'));
      lead = null;
    }

    const packet = super.formBeforeSubmit(data);

    packet.lead.source = environment.auth.active.source;
    packet.lead.productCategory = 'motor-vehicle';

    if (!packet.parties.find(x => x.value === LCA_ORIGINATOR_PARTY_ROLE_ID && x.referenceType === 'partyRoleId')) {
      packet.lead.status = 'live-app';
    } else {
      packet.purposes[0].channel = 'retail'; // create retail ontrack account for this person
    }
    return packet;
  }

}
